export const FORM_ACTION = 'FORM_ACTION'
export const FORM_ALERT = 'FORM_ALERT'
export const FORM_FIELD = 'FORM_FIELD'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'
export const SET_FORM_STATE = 'SET_FORM_STATE'
export const SET_REASON_INPUTS = 'SET_REASON_INPUTS'
export const FORM_SELECTED_TOPIC = 'FORM_SELECTED_TOPIC'
export const FORM_REASON_NAME = 'FORM_REASON_NAME'
